import { render, staticRenderFns } from "./InputMap.vue?vue&type=template&id=6454c2a0&scoped=true&"
import script from "./InputMap.vue?vue&type=script&lang=js&"
export * from "./InputMap.vue?vue&type=script&lang=js&"
import style0 from "./InputMap.vue?vue&type=style&index=0&id=6454c2a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6454c2a0",
  null
  
)

export default component.exports